export enum UserTableCreators {
  MANAGE_USERS,
  MANAGE_USER_INFOS,
  PERSONAL_USER_INVITES_FOR_COMMUNITY,
  PERSONAL_USER_REQUESTS_FOR_COMMUNITY,
  PERSONAL_USER_INVITES_FOR_PROJECT,
  PERSONAL_USER_REQUESTS_FOR_PROJECT,
  ENTITY_USERS_INVITES,
  ENTITY_USERS_REQUESTS,

  FAKE,
}
